import { render, staticRenderFns } from "./PartnerSupport.vue?vue&type=template&id=70c3b4e2&scoped=true"
import script from "./PartnerSupport.vue?vue&type=script&lang=ts"
export * from "./PartnerSupport.vue?vue&type=script&lang=ts"
import style0 from "./PartnerSupport.vue?vue&type=style&index=0&id=70c3b4e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c3b4e2",
  null
  
)

export default component.exports